import ServiceImportTemplate from '../../../components/5templates/ServiceImportTemplate'
import DataImportFormTabs from '../../../components/3modules/DataImportFormTabs'
import {useNavigate, useParams} from 'react-router-dom'
import {useContext, useState} from 'react'
import {approveDataImportRecord, rejectDataImportRecord} from '../../../services/util/miscellaneousService'
import {getItemFromSessionStorage} from '../../../services/util/sessionStorageManager'
import {FeedbackSnackbar} from '../../../components/1elements'
import LoaderBackdrop from '../../../components/2compounds/LoaderBackdrop'
import {GlobalContext} from '../../../services/context/DataContext'

const ApproveServiceForm = () => {
    const navigate = useNavigate()
    const id = useParams().id
    const [serviceList, setServiceList] = useState({})
    const [selectedServiceType, setSelectedServiceType] = useState('')
    const [, setSelectedServiceTypeId] = useState('')
    const [options, setOptions] = useState([])
    const [snackbar, setSnackbar] = useState({isOpen: false, severity: "", message: "Information is successfully saved!"})
    const [isLoading, setIsLoading] = useState(false)
    const [loaded, setLoaded] = useState(false)
    const {dataManagementNotificationCount: dataManagementNotificationCountContext} = useContext(GlobalContext)
    const [, setDataManagementNotificationCount] = dataManagementNotificationCountContext

    const onApprove = () => {
        setIsLoading(true)
        approveDataImportRecord(id)
            .then(()=>{
                setLoaded(true)
                const snackbarCopy = {...snackbar}
                setSnackbar({...snackbarCopy, severity: 'success', isOpen: true})
                window.setTimeout(()=>{
                    setDataManagementNotificationCount(prevState => prevState - 1)
                    navigate('/adminDashboard')
                }, 2000)
            })
    }
    const onReject = (reason) => {
        setIsLoading(true)
        const initiatorEmail = getItemFromSessionStorage('initiatorEmail')
        rejectDataImportRecord(id, reason, initiatorEmail)
            .then(()=>{
                setLoaded(true)
                const snackbarCopy = {...snackbar}
                setSnackbar({...snackbarCopy, severity: 'success', isOpen: true})
                window.setTimeout(()=>{
                    navigate('/adminDashboard')
                }, 2000)
            })
    }


    return (
        <DataImportFormTabs flow={'addLocation'}>
            <ServiceImportTemplate serviceList={serviceList}
                                   setServiceList={setServiceList}
                                   onApprove={onApprove}
                                   onReject={onReject}
                                   options={options}
                                   selectedServiceType={selectedServiceType}
                                   setSelectedServiceType={setSelectedServiceType}
                                   setSelectedServiceTypeId={setSelectedServiceTypeId}
                                   setOptions={setOptions}
                                   disabled
            />
            <FeedbackSnackbar setSnackbar={setSnackbar} snackbar={snackbar} />
            <LoaderBackdrop open={isLoading} loaded={loaded} />
        </DataImportFormTabs>
    )
}

export default ApproveServiceForm
